export const dictionary = {
	farmacia: 'Retiro en farmacia',
	domicilio: 'Envío a domicilio',
};
